import { useEffect, useState } from "react";
import DriverWageRules from "@/pages/admin/DriverWageRules";
import api from "@/lib/api";
import { UserCircle } from "@phosphor-icons/react";

// External-driver wage rules — same layout as fleet rules but each rule
// must be tied to a specific external driver (per-driver pricing).
export default function ExternalDriverWageRules() {
  const [extDrivers, setExtDrivers] = useState([]);

  useEffect(() => {
    api.get("/admin/external-drivers")
      .then((r) => setExtDrivers(Array.isArray(r.data) ? r.data.filter((d) => d.is_active !== false) : []))
      .catch(() => setExtDrivers([]));
  }, []);

  return (
    <DriverWageRules
      endpointBase="/admin/external-driver-wage-rules"
      pageTitle="مسارات أجرة السائقين الخارجيين"
      entityLabel="السائق الخارجي"
      extraFormDefaults={{ external_driver_id: "" }}
      extraValidate={(form) => {
        if (!form.external_driver_id) return "اختر السائق الخارجي أولاً";
        return null;
      }}
      extraSavePayload={(form) => ({ external_driver_id: form.external_driver_id })}
      extraFormFields={(form, setForm) => (
        <div>
          <label className="block text-white/70 text-xs mb-1">
            السائق الخارجي <span className="text-red-400">*</span>
          </label>
          <select
            value={form.external_driver_id || ""}
            onChange={(e) => setForm({ ...form, external_driver_id: e.target.value })}
            className="w-full bg-[#0B1A3A] border border-primary/25 rounded-lg px-3 py-2 text-white focus:outline-none focus:border-primary/60"
            data-testid="wage-rule-external-driver"
          >
            <option value="">— اختر سائقاً —</option>
            {extDrivers.map((d) => {
              const cityLabel = d.base_city === "makkah" ? "🕌 مكة" : d.base_city === "madinah" ? "🌙 المدينة" : "";
              return (
                <option key={d.id} value={d.id}>
                  {d.name} {cityLabel ? `— ${cityLabel}` : ""}
                </option>
              );
            })}
          </select>
          {extDrivers.length === 0 && (
            <p className="text-amber-400 text-[11px] mt-1">
              لا يوجد سائقون خارجيون نشطون. أضف سائقاً من صفحة السائقين الخارجيين أولاً.
            </p>
          )}
        </div>
      )}
      extraColumn={{
        header: "السائق",
        cell: (r) => (
          <span className="inline-flex items-center gap-1 text-primary font-semibold">
            <UserCircle size={14} weight="duotone" />
            {r.external_driver_name || <span className="text-white/40">—</span>}
          </span>
        ),
      }}
    />
  );
}
